import React from "react";
import { Form } from "react-bootstrap";
import { TLevelistOption } from "../../../../../api/endpoints/SubsetOption";
import Footnote from "../../../Footnote";
import FormError from "../../../FormError";
import LevelistSelector from "../../../LevelistSelector";
import { FormikProductFormField, TFormErrorMessage } from "../../index";

interface Props extends FormikProductFormField {
  spec: TLevelistOption;
}

const LevelistField = (props: Props) => {
  const { formik, spec } = props;

  return (
    <Form.Group controlId="levelist">
      <Form.Label>Levels</Form.Label>
      <LevelistSelector
        spec={spec}
        values={formik.values.levelist}
        onChange={values => formik.setFieldValue('levelist', values)}
      />

      <FormError
        message={formik.errors.levelist as TFormErrorMessage}
        when={formik.touched.levelist && Boolean(formik.errors.levelist)}
      />

      <Footnote text={spec.footnote} />
    </Form.Group>
  )
}

export default LevelistField;
